module.exports = __webpack_public_path__ + "topvillas-logo.png?c518ae15163cc651f4aad15ac705cb6f";